import { Typography } from "antd";
import EducationTable from "components/Resources/EducationTable";
import './index.scss';

const { Title } = Typography;

const EducationPage = () => {

  return (
    <div className="education-material-page">
      <div className="header-title">
        <Title level={4}>&nbsp;&nbsp;&nbsp;Patient Resources</Title>
      </div>
      <div className="content">
        <EducationTable />
      </div>
    </div>
  );
}

export default EducationPage;